// src/components/gear/GearTabs.jsx

import React from "react";

const DEFAULT_TABS = [
  { key: "equipment", label: "Equipment" },
  { key: "maintenance", label: "Maintenance" },
  { key: "events", label: "Event History" },
  { key: "archive", label: "Archive" },
];

export default function GearTabs({ activeTab, onChange, tabs, variant = "default" }) {
  const list = Array.isArray(tabs) && tabs.length ? tabs : DEFAULT_TABS;
  const isBare = variant === "bare";

  return (
    <div className={isBare ? "flex items-end justify-between gap-3" : "flex items-end justify-between gap-3 border-b border-gray-200 mb-1 md:mb-3"}>
      <div className="flex flex-1 gap-6 justify-center md:justify-start overflow-x-auto md:overflow-visible">
        {list.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`pb-2 font-semibold text-sm transition whitespace-nowrap ${
              activeTab === tab.key
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.icon ? (
              <span className="inline-flex mr-2 align-middle md:hidden">
                {tab.icon}
              </span>
            ) : null}
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
